export default "__VITE_ASSET__BPI0B1dv__"